<div class="flex align-items-center gap-2">
  @if (icon) {
    <i [class]="icon"></i>
  }
  <span>{{ label }}</span>
</div>
